import { StorageKeys, ErrorCodes } from 'src/app/utils/common-classes';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@angular/material/snack-bar";
import * as i3 from "@ngx-translate/core";
import * as i4 from "../Auth/auth.service";
export class UtilsService {
    constructor(router, snackBar, translate, authService) {
        this.router = router;
        this.snackBar = snackBar;
        this.translate = translate;
        this.authService = authService;
        this.loading = false;
        this.dialogUnclosable = false;
        let language = localStorage.getItem(StorageKeys.LANGUAGE);
        if (language) {
            this.language = language;
        }
        else {
            this.language = "it";
        }
    }
    showShortLoader() {
        this.loading = true;
        document.body.classList.add('loading');
    }
    hideShortLoader() {
        this.loading = false;
        document.body.classList.remove('loading');
    }
    setDialogUnclosable(dialogUnclosable) {
        this.dialogUnclosable = dialogUnclosable;
    }
    showToast(message) {
        this.snackBar.open(message, "OK", { duration: 5000, panelClass: ["success-toast"] });
    }
    showErrorToast(message) {
        this.snackBar.open(message, "OK", { duration: 5000, panelClass: ["error-toast"] });
    }
    waitMilliseconds(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    translateKey(key) {
        let _self = this;
        return new Promise((resolve, reject) => {
            _self.translate.get(key).subscribe((value) => {
                resolve(value);
            });
        });
    }
    translateKeyWithData(key, data) {
        let _self = this;
        return new Promise((resolve, reject) => {
            _self.translate.get(key, data).subscribe((value) => {
                resolve(value);
            });
        });
    }
    getErrorKey(error) {
        let errorKey = "general.error.unknown-error";
        switch (error) {
            case ErrorCodes.INVALID_PATH:
                errorKey = "general.error.invalid-path";
                break;
            case ErrorCodes.MISSING_REQUIRED_DATA:
                errorKey = "general.error.missing-required-data";
                break;
            case ErrorCodes.INVALID_SERVICE:
                errorKey = "general.error.invalid-service";
                break;
            case ErrorCodes.INVALID_FOLDER_NAME:
                errorKey = "general.error.invalid-folder-name";
                break;
            case ErrorCodes.DUPLICATE_FILE_NAME:
                errorKey = "general.error.duplicate-file-name";
                break;
            case ErrorCodes.DUPLICATE_FOLDER_NAME:
                errorKey = "general.error.duplicate-folder-name";
                break;
            case ErrorCodes.PARENT_FOLDER_NOT_FOUND:
                errorKey = "general.error.parent-folder-not-found";
                break;
            case ErrorCodes.DESTINATION_IS_SUBFOLDER:
                errorKey = "general.error.destination-is-subfolder";
                break;
            case ErrorCodes.USER_NOT_FOUND:
                errorKey = "general.error.user-not-found";
                break;
            case ErrorCodes.FILE_NOT_FOUND:
                errorKey = "general.error.file-not-found";
                break;
            case ErrorCodes.FOLDER_NOT_FOUND:
                errorKey = "general.error.folder-not-found";
                break;
            case ErrorCodes.TREE_NOT_FOUND:
                errorKey = "general.error.tree-not-found";
                break;
            case ErrorCodes.SESSION_NOT_FOUND:
                errorKey = "general.error.session-not-found";
                break;
            case ErrorCodes.DUPLICATE_TREE_NAME:
                errorKey = "general.error.duplicate-tree-name";
                break;
            case ErrorCodes.UNKNOWN_ERROR:
                errorKey = "general.error.unknown-error";
                break;
            case ErrorCodes.CONNECTION_REFUSED:
                errorKey = "general.error.connection-refused";
                break;
            case ErrorCodes.LOAD_PREVIEW_ERROR:
                errorKey = "general.error.load-preview-error";
                break;
        }
        return errorKey;
    }
    getErrorShowToast(error) {
        let _self = this;
        return new Promise((resolve, reject) => {
            _self.getError(error).then((translatedError) => {
                if (translatedError) {
                    _self.showErrorToast(translatedError);
                }
                resolve();
            });
        });
    }
    getError(error) {
        let _self = this;
        return new Promise((resolve, reject) => {
            let errorKey = "general.error.unknown-error";
            if (error) {
                if (error.status == 0) {
                    errorKey = _self.getErrorKey(ErrorCodes.CONNECTION_REFUSED);
                    _self.translateKey(errorKey).then((translatedKey) => {
                        resolve(translatedKey);
                    });
                }
                else if (error.error) {
                    let errorObject = error.error;
                    if (typeof (errorObject) === "string") {
                        //è una string converto
                        if (errorObject == ErrorCodes.SESSION_NOT_FOUND) {
                            _self.authService.logout().then(() => {
                                errorKey = _self.getErrorKey(errorObject);
                                return _self.router.navigate(['login']);
                            }).then(() => {
                                return _self.translateKey(errorKey);
                            }).then((translatedKey) => {
                                //mostro il toaster di errore session scaduta SEMPRE
                                _self.showErrorToast(translatedKey);
                                //ritorno null per non mostrare 2 volte il toster
                                resolve(null);
                            });
                        }
                        else {
                            errorKey = _self.getErrorKey(errorObject);
                            _self.translateKey(errorKey).then((translatedKey) => {
                                resolve(translatedKey);
                            });
                        }
                    }
                    else if (errorObject.error && typeof (errorObject.error) === "string") {
                        if (errorObject.error == ErrorCodes.SESSION_NOT_FOUND) {
                            _self.authService.logout().then(() => {
                                errorKey = _self.getErrorKey(errorObject.error);
                                return _self.router.navigate(['login']);
                            }).then(() => {
                                return _self.translateKey(errorKey);
                            }).then((translatedKey) => {
                                //mostro il toaster di errore session scaduta SEMPRE
                                _self.showErrorToast(translatedKey);
                                //ritorno null per non mostrare 2 volte il toster
                                resolve(null);
                            });
                        }
                        else {
                            errorKey = _self.getErrorKey(errorObject.error);
                            _self.translateKey(errorKey).then((translatedKey) => {
                                resolve(translatedKey);
                            });
                        }
                    }
                    else if (errorObject.message && typeof (errorObject.message) === "string") {
                        resolve(errorObject.message);
                    }
                    else {
                        _self.translateKey(errorKey).then((translatedKey) => {
                            resolve(translatedKey);
                        });
                    }
                }
                else {
                    _self.translateKey(errorKey).then((translatedKey) => {
                        resolve(translatedKey);
                    });
                }
            }
            else {
                _self.translateKey(errorKey).then((translatedKey) => {
                    resolve(translatedKey);
                });
            }
        });
    }
    getLanguage() {
        return this.language;
    }
    setLanguage(language) {
        let _self = this;
        _self.language = language;
        localStorage.setItem(StorageKeys.LANGUAGE, language);
        _self.translate.use(language);
    }
    isLoading() {
        return this.loading;
    }
    isDialogUnclosable() {
        return this.dialogUnclosable;
    }
}
UtilsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UtilsService_Factory() { return new UtilsService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.MatSnackBar), i0.ɵɵinject(i3.TranslateService), i0.ɵɵinject(i4.AuthService)); }, token: UtilsService, providedIn: "root" });
